import HttpException from './HttpException';

export default class UnexpectedResponseHttpException extends HttpException {
	name = 'UnexpectedResponseHttpException';

	constructor(response: Response) {
		super(response, 'Exceptions.services.http.unexpected_response');
	}
}
